import { render, staticRenderFns } from "./refactor.vue?vue&type=template&id=5a9f63d3&scoped=true"
import script from "./refactor.vue?vue&type=script&lang=ts"
export * from "./refactor.vue?vue&type=script&lang=ts"
import style0 from "./refactor.vue?vue&type=style&index=0&id=5a9f63d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9f63d3",
  null
  
)

export default component.exports